import { DESCRIPTIONS } from '../../../../modules/trade-approval/constants'
import { CheckboxWithLabel, ModalHeader, SimpleModal, Space, Typography } from '../..'
import Icon from '../../atoms/Icon/Icon'
import IconButton from '../../molecules/iconButton/iconButton'

export type CommitModalProps = {
  isAuthorised: boolean
  onClose: () => void
  onCommit: () => void
  onSetAuthorisation: (isAuthorised: boolean) => void
}

export const CommitModal = ({
  isAuthorised,
  onClose,
  onCommit,
  onSetAuthorisation
}: CommitModalProps) => (
  <SimpleModal>
    <ModalHeader onClickClose={() => onClose()}>Confirm trade commitment</ModalHeader>
    <Space p={6}>
      <Space mb={6}>
        <Typography fontSize={13} variant="b3">
          {DESCRIPTIONS.CONFIRM_TRADE_COMMIT}
        </Typography>
      </Space>
      <Space mb={6}>
        <CheckboxWithLabel checked={isAuthorised} onChange={onSetAuthorisation}>
          Confirm authorisation
        </CheckboxWithLabel>
      </Space>
      <Space isinlineblock mr={2}>
        <IconButton
          disabled={!isAuthorised}
          icon={<Icon name="check" size="medium" />}
          iconPosition="left"
          operationType="progress"
          text="Commit to trade"
          onClick={() => onCommit()}
        />
      </Space>
      <Space isinlineblock ml={2}>
        <IconButton
          disabled={false}
          icon={<Icon name="circleX" size="medium" />}
          iconPosition="left"
          operationType="cancel"
          text="Cancel"
          onClick={() => onClose()}
        />
      </Space>
    </Space>
  </SimpleModal>
)

export default CommitModal
